import {
  montserratBold,
  montserratMedium,
  montserratNormal,
  montserratSemibold,
} from "@/assets/fonts/montserrat";
import { pricingSection } from "@/helpers/content/id/pricing";
import { pricing } from "@/helpers/content/id/services/bookeeping/pricing-list";
import {
  ArrowTrendingUpIcon,
  CheckIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { ArrowTrendingDownIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function PricingList({ pricingRef, moveToSection }) {
  const [typePricing, setTypePricing] = useState(false);
  const [data, setdata] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    let type = !typePricing ? "monthly" : "yearly";
    let choosed = pricing.find((val) => val.type == type);
    setdata(choosed);
    console.log("aa");
  }, [typePricing]);

  const changePricing = () => {
    setTypePricing((prev) => !prev);
  };

  return (
    <div
      ref={pricingRef}
      className="flex w-full h-full px-4 py-16 lg:px-8 lg:py-[100px] max-w-[1280px] lg:mx-auto lg:container flex-col"
    >
      <div className="flex flex-col lg:flex-row w-full justify-between">
        <div className="flex flex-col lg:justify-start lg:items-start items-center lg:text-justify text-center justify-center">
          <p
            className={`${montserratMedium.className} text-sm text-blue-primary-500`}
          >
            {t("price")}
          </p>
          <p
            className={`${montserratSemibold.className} leading-[44px] text-[36px] text-gray-cool-700 py-1`}
          >
            {t("bookeeping_packages_based")}
          </p>
        </div>
        <div className="flex flex-col md:flex-row md:space-x-6 lg:space-x-0 lg:flex-col lg:py-0 py-6 lg:justify-end lg:items-end justify-center items-center">
          <div
            onClick={() => changePricing()}
            className="flex hover:cursor-pointer space-x-4 justify-center lg:justify-end lg:items-end"
          >
            <div
              className={`${
                !typePricing ? "text-gray-cool-700" : "text-gray-cool-400"
              } ${montserratNormal.className}`}
            >
              {t("monthly_bookeeping")}
            </div>
            <div
              className={`${
                !typePricing ? "bg-gray-cool-400" : "bg-blue-primary-500"
              } flex relative px-6 justify-center items-center rounded-full h-[2rem] w-[4rem]`}
            >
              <div
                className={`${
                  typePricing
                    ? "duration-100 transition ease-in-out transform -translate-x-0"
                    : "duration-100 transition ease-in-out transform -translate-x-8"
                } h-6 w-6 rounded-full hover:cursor-pointer mx-1 bg-base-white absolute right-0`}
              ></div>
            </div>
            <div
              className={`${
                typePricing ? "text-gray-cool-700" : "text-gray-cool-400"
              } ${montserratNormal.className}`}
            >
              {t("yearly_bookeeping")}
            </div>
          </div>
          <div
            className={`flex py-[1px] text-xs font-medium mt-3 md:mt-0 lg:mt-3 px-3 rounded-[10px] bg-semantic-positive-100 text-semantic-positive-800 ${montserratNormal.className}`}
          >
            {t("bookeeping_service_disc")}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-[60px]">
        {data?.data.map((val, index) => (
          <div className="rounded-2xl justify-between pt-[60px] flex flex-col">
            <div className="flex w-full justify-between">
              <div
                className={`flex w-full p-[1px] h-full rounded-lg overflow-hidden relative justify-center items-center`}
              >
                {index == 1 && (
                  <div className="flex -z-10 w-full h-full bg-gradient-to-bl absolute via-45% from-[#D6EAFF] via-blue-primary-500 to[#D6EAFF]"></div>
                )}
                <div
                  className={`flex p-6 ${
                    index == 0
                      ? ""
                      : "bg-gray-cool-50 overflow-y-auto border-[1px] border-gray-cool-200 "
                  } relative rounded-lg w-full flex-col`}
                >
                  <div className="flex items-center space-x-6 w-full">
                    <p
                      className={`${montserratMedium.className} text-gray-cool-700 text-[20px]`}
                    >
                      {t(val.title)}
                    </p>
                    {val.is_populer && (
                      <div
                        className={`${montserratMedium.className} bg-semantic-positive-100 rounded justify-center items-center flex flex-row w-fit h-fit px-[10px]`}
                      >
                        <div>
                          <ArrowTrendingUpIcon className="w-5 h-5 text-semantic-positive-800"></ArrowTrendingUpIcon>
                        </div>
                        <div className="text-base ml-2 text-semantic-positive-800 font-medium">
                          Populer
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    className={`${
                      !typePricing ? " items-center" : ""
                    } flex pt-3 w-full whitespace-nowrap flex-col md:flex-row`}
                  >
                    <p
                      className={`rounded-md flex w-fit px-[10px] pt-1 ${montserratBold.className} h-fit text-[32px] text-black leading-[38.4px]`}
                    >
                      {val.price}
                    </p>
                    <div className="flex h-full w-full flex-col">
                      {val.old_price != "" && (
                        <p
                          className={`${montserratNormal.className} text-gray-cool-500 flex pb-[1px]  line-through leading-snug pl-2`}
                        >
                          {val.old_price}
                        </p>
                      )}
                      <div className="flex w-full h-full items-center">
                        <p
                          className={`${
                            val.old_price != ""
                              ? ""
                              : "justify-center h-full items-center"
                          } flex text-gray-cool-700 h-full leading-snug  pl-2 ${
                            montserratNormal.className
                          }`}
                        >
                          {typePricing
                            ? `${"/" + t("yearly")}`
                            : `${"/" + t("monthly")}`}
                        </p>
                        {val.discount != "" && (
                          <div
                            className={`flex items-center rounded-full h-fit justify-center ml-2 ${montserratNormal.className} px-[10px] text-xs bg-semantic-positive-100 text-semantic-positive-800 font-medium`}
                          >
                            {t(val.discount)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${montserratNormal.className} text-gray-cool-500 max-w-[520px] flex flex-col py-6`}
                  >
                    {t(val.description)}
                  </div>
                  <div
                    className={`${montserratNormal.className} text-gray-cool-700 w-full flex py-6 items-center whitespace-nowrap`}
                  >
                    {t("bookeeping_whats_included")}{" "}
                    <span className="border-[1px] mx-4 col-span-3 w-full h-[1px] border-gray-cool-200"></span>
                  </div>
                  <div
                    className={`flex w-full h-full justify-between flex-col relative`}
                  >
                    <div className="flex space-y-6 w-full h-full flex-col relative">
                      {val.list.map((v) => (
                        <div className="flex w-full items-center relative ">
                          <div
                            className={`flex absolute left-0 justify-center w-5 rounded-full ${
                              v.active
                                ? " bg-blue-primary-50 text-blue-primary-500"
                                : "text-gray-cool-500"
                            } `}
                          >
                            {v.active ? <CheckIcon /> : <XMarkIcon />}
                          </div>
                          <div
                            className={`flex items-center relative left-8 ${
                              montserratNormal.className
                            } ${
                              v.active
                                ? "text-gray-cool-700"
                                : "text-gray-cool-400"
                            }`}
                          >
                            {t(v.name)}{" "}
                            <p className="flex text-xs pl-1">{t(v.subname)}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="flex mt-[48px] justify-end flex-col">
                      <span className={`${montserratMedium.className}`}>
                        {t("pricing_not_include_ppn")}
                      </span>
                      <button
                        onClick={() => moveToSection("contact")}
                        className={`w-full mt-6 bg-blue-primary-500 rounded py-2 hover:cursor-pointer hover:bg-blue-primary-600 text-base-white flex justify-center ${montserratNormal.className}`}
                      >
                        {t("pricing_button_text")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
